import React from "react";
import PropTypes from "prop-types";

import {createUseStyles} from "react-jss";
import styles from "../../assets/jss/material-dashboard-pro-react/components/typographyStyle.js";
const useStyles = createUseStyles(styles);

export default function Success(props) {
  const classes = useStyles();
  const { children } = props;
  return (
    <div className={classes.defaultFontStyle + " " + classes.successText}>
      {children}
    </div>
  );
}

Success.propTypes = {
  children: PropTypes.node
};
